import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HandPlatterIcon } from 'lucide-react';
import { Button } from '@/shared/shadcn';
import { openUrlInTelegram } from '@/shared/lib';

interface CatalogReservationButtonProps {
  reservationUrl: string;
  className?: string;
  isMinimalistic?: boolean;
}

export const CatalogReservationButton: FC<CatalogReservationButtonProps> = ({
  className,
  reservationUrl,
  isMinimalistic,
}) => {
  const { t } = useTranslation('catalog');

  return (
    <Button size='default' variant='secondary' className={className} onClick={() => openUrlInTelegram(reservationUrl)}>
      {!isMinimalistic && <HandPlatterIcon size={16} />}
      {t('reservation.title')}
    </Button>
  );
};
